import { Container, ContainerPadding, CTA, styled } from '@volkswagen-onehub/components-core';
import { CloseHandleV2, FocusLayerSizeV2, LayerHandleV2, LayerManagerV2 } from '@volkswagen-onehub/layer-manager';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Apellido, Email, KoScreen, LoadingScreen, Nombre, Telefono } from 'src/components';
import {
	LayerManagerWrapper,
	useFeatureAppEnvironment,
	useFeatureServices,
	useOneFormContext,
	useTrackingManager,
} from 'src/feature-app';
import { MGMFieldsProps } from 'src/forms';

import { OneFormState } from 'src/types';
import { MGMTitle } from './MGMLayout';

const ConfirmacionWrapper = styled.div``;

export function BonoClienteFields({ title, copy }: MGMFieldsProps) {
  return (
    <ConfirmacionWrapper>
      <MGMTitle title={title} copy={copy} />
      <Container wrap={'always'} padding={{ bottom: ContainerPadding.static500 }}>
          <Nombre />
          <Apellido name="surname" required label="Primer apellido" />
        <Email required />
        <Telefono required={true} />
      </Container>
      <div className="last-navigation-position" style={{ width: '100%', display: 'flex' }}>
        <LastNavigation />
      </div>
    </ConfirmacionWrapper>
  );
}

function LastNavigation() {
  // const dispatch = useDispatch();
  const { handleShowFinalScreen, handleSubmit } = useOneFormContext();
  const { getValues, triggerValidation } = useFormContext();
  const [layerVisible, setLayerVisible] = useState<boolean>(false);
  const [koLayer, setKoLayer] = useState<LayerHandleV2<any>>(null);
  const [koScreen, setKoScreen] = useState<boolean>(false);
  const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
  const store = useStore();
  const env = useFeatureAppEnvironment();
  const dispatch = useDispatch();
  const trackingManager = useTrackingManager();
  const { formData } = useSelector((state: OneFormState) => state);

  //Loading and Ko layers

  const handleKoLayer = () => {
    const layer = layerManager.openFocusLayer(renderKoLayer, {}, { size: FocusLayerSizeV2.A });
    setKoLayer(layer);
  };

  const renderKoLayer = (state: any, close: CloseHandleV2<any, any>) => {
    const NoCompraTitle = 'Uy, algo ha pasado';
    const NoCompraBody = 'Por alguna razón no hemos podido guardar tu respuesta. ¿Lo intentamos de nuevo? ';

    return (
      <LayerManagerWrapper store={store} env={env}>
        <KoScreen
          retrySubmit={retrySubmit}
          closeLayerCallback={close}
          title={NoCompraTitle}
          bodyCopy={NoCompraBody}
          isLEM={true}
        />
      </LayerManagerWrapper>
    );
  };

  const handleLoadingScreenLayer = () => {
    const layer = layerManager.openFocusLayer(renderLoadingScreen, {}, { size: FocusLayerSizeV2.A });

    return layer;
  };

  const renderLoadingScreen = (state: any, close: CloseHandleV2<any, any>) => {
    return (
      <LayerManagerWrapper store={store} env={env}>
        <LoadingScreen copy="Enviando tu respuesta" />
      </LayerManagerWrapper>
    );
  };

  async function handleConfirmarCita(e: any) {
    trackingManager.trackFormCTAClick({
      contentId: 'Quiero mi bono',
    });

    const isValid = await triggerValidation();

    if (isValid) {
      const loadingLayer = handleLoadingScreenLayer();
      setLayerVisible(true);

      const value = await handleSubmit(e);
      loadingLayer.close();

      if (value) {
        handleShowFinalScreen();
      } else {
        handleKoLayer();
      }
    }
  }

  async function retrySubmit(e: any) {
    if (koLayer) {
      koLayer.close();
    }
    setKoScreen(false);
    const loadingLayer = handleLoadingScreenLayer();
    const value = await handleSubmit(e);
    loadingLayer.close();
    if (value) {
      handleShowFinalScreen();
    } else {
      handleKoLayer();
      setKoScreen(true);
    }
  }

  useEffect(() => {
    if (!layerVisible && koScreen) setKoScreen(false);
  }, [layerVisible]);

  useEffect(() => {
    dispatch({ type: 'UPDATE_FORM_ENDED', payload: true });
  }, []);

  return (
    <>
      <CTA
        tag="button"
        type="submit"
        emphasis="primary"
        onClick={(e) => {
          e.preventDefault();
          handleConfirmarCita(e);
        }}
        stretchContent={window.innerWidth <= 560}
      >
        Quiero mi bono
      </CTA>
    </>
  );
}
